module.exports = __webpack_public_path__ + "static/media/avatar_placeholder.23ce4bfd.svg";